import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadPastReport,
  getSubscriptions,
  setPastReportDateRange,
} from "../../../../store/actions/subscriptionsActions";
import SubscriptionSelection from "./components/SubscriptionSelection";
import _ from "lodash";
import { Box, Button } from "@chakra-ui/react";
import DatePicker from "../../../filterForm/DatePicker";
import { Download } from "lucide-react";
import PastReportDownloadSummary from "./PastReportDownloadSummary";

const PastReportsForm = () => {
  const { organizationId, reportTypes } = useSelector((store) => store.defaultReducer);
  const { userData } = useSelector((store) => store.authReducer);
  const {
    subscriptions,
    subscriptionId,
    downloadingReport,
    pastReportDateRange,
  } = useSelector((store) => store.subscriptionsReducer);
  const subscriptionsClone = _.cloneDeep(subscriptions);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSubscriptions(userData.id, organizationId));
  }, [organizationId]);

  const selectedSubscription = subscriptionsClone.find((a) => a.id === subscriptionId);
  const subscriptionReportRange = selectedSubscription?.reportRange;
  const data = {
    subscription: selectedSubscription,
    dateRange: pastReportDateRange,
  };
  return (
    <Box>
      <SubscriptionSelection />
      {subscriptionId.length > 0 ? (
        <Box mt={5}>
          <DatePicker
            onDateRangeChange={setPastReportDateRange}
            calendarType={subscriptionReportRange}
            selectedDateRange={pastReportDateRange}
          />
        </Box>
      ) : null}

      {subscriptionId.length > 0 ? (
        <Box mt={5}>
          <PastReportDownloadSummary
            subscription={selectedSubscription}
            dateRange={pastReportDateRange}
            reportTypes={reportTypes}
          />
        </Box>
      ) : null}

      {subscriptionId.length > 0 ? (
        <Box display="flex" justifyContent="center" alignItems="center" mt={5}>
          <Button
            loading={downloadingReport}
            loadingText="Downloading..."
            size="md"
            gap="8px"
            onClick={() => {
              dispatch(downloadPastReport(data));
            }}
          >
            <Download size={18} />
            Download
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export default PastReportsForm;
